/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';
import {Badge, NavDropdown , Button} from 'react-bootstrap'

import GeneralTable from '../general_table.js';
import Translation from '../../store/internationalization-store.js';
import {ClassesService} from '../../services/';
import {ClassesStore} from '../../store';
import Constants from '../../constants.js';

export default class Members extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
        };
    }

    componentWillMount(){
        ClassesStore.on(Constants.GET_TEACHERS , () =>{

            console.log(ClassesStore.teachers);

            this.setState({
                teachers:ClassesStore.teachers || []
            })

        })
    }

    componentDidMount(){
        ClassesService.getTeachers(this.props.classID)
    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    renderOptions(cell, row){

        return    <NavDropdown className="pull-right" style={{padding:'0px' , margin:'0px'}} drop={"down"} title="Options" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.4">Students Profile</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">{Translation.get(12759,'Download Logins')}</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.3">Remove</NavDropdown.Item>
        </NavDropdown>

    }

    renderProfileLink(cell, row){
        return <a href="#">{cell}</a>
    }

    percentage(){
        return <span>0%</span>
    }

    getCols(){

        const columns = [
            {
                dataField: 'name',
                text: Translation.get(12628, 'Teacher Name'),
                sort: true,
                align: "left",
            },{
                dataField: 'email',
                text: Translation.get(9, 'Email'),

                align: "left",
            },{
                dataField: 'classes',
                text: Translation.get(830, 'Classes'),

                align: "left",
                formatter:(cell , row)=>{
                    var data = [];
                    for (var i = 0; i < cell.length; i++) {
                        data.push(<Badge variant="primary">{cell[i]}</Badge>)
                        data.push(" ")
                    }
                    return data;
                },
                csvFormatter:(cell , row)=>{
                    var data = "";
                    for (var i = 0; i < cell.length; i++) {
                        data += cell[i];
                        data += ", ";
                    }
                    return data;
                }
            }]

        return columns;
    }

    render(){

        if(!this.state.teachers)
        {
            return null;
        }

        return <div>
            <div>
                <GeneralTable  bordered={ true } keyField='id' data={ this.state.teachers || [] } columns={ this.getCols() } />
            </div>
        </div>
    }
}
